var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { KtsConstructionTaskService } from '../task/construction-task.service';
var KtsReportDownloadComponent = /** @class */ (function (_super) {
    __extends(KtsReportDownloadComponent, _super);
    function KtsReportDownloadComponent(router, route, logger, action, message, page, service, constTaskService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.constTaskService = constTaskService;
        _this.display_checked = false;
        // true:一般工事, false:展開工事
        _this.general = false;
        // 選択中の工種
        _this.selectedCc = 'all';
        // 工種選択
        _this.optCcs = [];
        _this.taskId = 'all';
        _this.task = [];
        // 全項目
        _this.allItems = [];
        // 表示項目
        _this.dispItems = [];
        // チェックされた項目
        _this.checkedItems = [];
        _this.fileItems = [];
        _this.fileCols = [];
        _this.outputFileItem = {};
        _this.outputFileCols = [];
        _this.zip = false;
        return _this;
    }
    KtsReportDownloadComponent.prototype.ngOnInit = function () {
        this.zip = jsonpath.value(this.component, '$.params.zip') || false;
        _super.prototype.ngOnInit.call(this);
    };
    KtsReportDownloadComponent.prototype.onMsg = function (msg) {
        this.reportList = new ReportList(msg);
        if (this.zip) {
            this.fileCols = this.general ? this.reportList.zip_general : this.reportList.zip_expand;
        }
        else {
            this.fileCols = this.general ? this.reportList.general : this.reportList.expand;
        }
    };
    KtsReportDownloadComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
    };
    KtsReportDownloadComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            this.general = data.construction_type === 'general';
            if (this.zip) {
                this.fileCols = this.general ? this.reportList.zip_general : this.reportList.zip_expand;
            }
            else {
                this.fileCols = this.general ? this.reportList.general : this.reportList.expand;
            }
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array)) {
            return;
        }
        this.service.getType('CONSTRUCTION_REPORT_TYPE').subscribe(function (rec) {
            var items = [];
            var reportType = {};
            rec.map(function (x) { return reportType[x.code] = x.display; });
            var isProgressData;
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                isProgressData = typeof item.id !== 'undefined';
                item.disp_cc = _this.getDispCc(item);
                item.disp_term = _this.getDispTerm(item);
                item.shooting_date = _this.getDate(item);
                items.push(Object.assign(new ConstructionFile(), item, { type: reportType[item.type] }));
            }
            _this.allItems = [];
            var sort_id = 1;
            if (isProgressData) {
                for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                    var item = items_1[_b];
                    item.sort_id = sort_id++ * 10;
                    _this.allItems.push(item);
                }
            }
            else {
                var _loop_1 = function (option) {
                    for (var _i = 0, _a = items.filter(function (x) { return x.type === option.display; }); _i < _a.length; _i++) {
                        var item = _a[_i];
                        item.sort_id = sort_id++ * 10;
                        _this.allItems.push(item);
                    }
                };
                for (var _c = 0, rec_1 = rec; _c < rec_1.length; _c++) {
                    var option = rec_1[_c];
                    _loop_1(option);
                }
            }
            _this.setNos(_this.allItems);
            _this.dispItems = _this.allItems;
        });
    };
    // 「表示用の工種」を取得する
    KtsReportDownloadComponent.prototype.getDispCc = function (cf) {
        if (!cf.cc_major && !cf.cc_middle) {
            return '';
        }
        return (cf.cc_major || '') + '／' + (cf.cc_middle || '');
    };
    // 「表示用の工事期間」を取得する
    KtsReportDownloadComponent.prototype.getDispTerm = function (cf) {
        if (!cf.visiting_actual_date && !cf.leaving_actual_date) {
            return '';
        }
        return (cf.visiting_actual_date || '') + ' - ' + (cf.leaving_actual_date || '');
    };
    // 「撮影日時」とは別に「撮影日」を取得する
    KtsReportDownloadComponent.prototype.getDate = function (item) {
        var shooting_datetime = item['shooting_date'] ? item['shooting_date'] : item['cdate'];
        var splitDatetime = shooting_datetime.split(' ');
        var splitDate = splitDatetime[0].split('-');
        if (splitDate.length === 3) {
            return splitDate.join('/');
        }
        return shooting_datetime;
    };
    KtsReportDownloadComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
        }
    };
    KtsReportDownloadComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === "sort") {
            this.display_checked = false;
            this.sortItems();
        }
        else if (e2 === "displayChecked") {
            this.display_checked = true;
            this.dispItems = this.checkedItems;
        }
        else if (e2 === "displayAll") {
            this.display_checked = false;
            this.dispItems = this.allItems;
        }
    };
    // ソート処理
    // 優先順位は 1. チェック有, 2. 並び替えID
    KtsReportDownloadComponent.prototype.sortItems = function () {
        var _this = this;
        var items = [];
        this.allItems.forEach(function (aItem) { return items.push({
            is_checked: aItem.is_checked,
            file_id: aItem.construction_file_id,
            sort_id: aItem.sort_id,
            cdate: new Date(aItem.cdate)
        }); });
        // 並び替えIDでソート
        items.sort(function (a, b) {
            if (a.sort_id < b.sort_id)
                return -1;
            if (a.sort_id > b.sort_id)
                return 1;
            // 同じ並び替えIDが入力されている場合はcdateでソートする
            if (a.sort_id === b.sort_id) {
                if (a.cdate < b.cdate)
                    return -1;
                if (a.cdate > b.cdate)
                    return 1;
            }
            return 0;
        });
        // チェックでソート
        items.sort(function (a, b) {
            if (a.is_checked && !b.is_checked)
                return -1;
            if (!a.is_checked && b.is_checked)
                return 1;
            return 0;
        });
        var newAllItems = [];
        var sort_id = 1;
        items.forEach(function (i) {
            var item = _this.allItems.find(function (a) { return a.construction_file_id === i.file_id; });
            item.sort_id = sort_id++ * 10;
            newAllItems.push(item);
        });
        this.allItems = newAllItems;
        this.setNos(this.allItems);
        this.dispItems = this.allItems;
    };
    KtsReportDownloadComponent.prototype.getItems = function () {
        return this.dispItems;
    };
    KtsReportDownloadComponent.prototype.onChangeItems = function (e) {
        var _this = this;
        var checkedItemIds = [];
        var _loop_2 = function (eItem) {
            if (eItem.is_checked) {
                checkedItemIds.push(eItem.construction_file_id);
            }
            this_1.allItems.filter(function (item) { return eItem.construction_file_id === item.construction_file_id; }).map(function (item) {
                item.is_checked = eItem.is_checked;
                item.type = eItem.type;
                item.content = eItem.content;
                item.shooting_location = eItem.shooting_location;
                item.shooting_date = eItem.shooting_date ? eItem.shooting_date : _this.getDate(eItem);
                item.sort_id = eItem.sort_id;
                item.subject = eItem.subject;
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = e.items; _i < _a.length; _i++) {
            var eItem = _a[_i];
            _loop_2(eItem);
        }
        this.checkedItems = this.allItems.filter(function (item) { return checkedItemIds.indexOf(item.construction_file_id) > -1; });
        this.setNos(this.checkedItems);
        this.setCompRec();
    };
    // 選択番号を設定する
    KtsReportDownloadComponent.prototype.setNos = function (items) {
        var count = 0;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item.is_checked) {
                item.no = ++count;
            }
            else {
                item.no = undefined;
            }
        }
    };
    KtsReportDownloadComponent.prototype.onChangeOutputFileItem = function (e) {
        this.outputFileItem[e.key] = e.val;
        this.setCompRec();
    };
    KtsReportDownloadComponent.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, Object.assign({}, {
            id: this.constructionMId,
            type: 'company',
            items: this.allItems
        }));
    };
    KtsReportDownloadComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-report-download',
                    template: "<div id=\"{{ componentName }}\">\n  <div class=\"row -mt-1\">\n    <div class=\"col -sm-12\">\n      <ng-template [ngIf]=\"zip == false\">\n        <ul [key]=\"'btn'\" buttonDir>\n          <li [key]=\"'btn'\" buttonDir>\n            <item-btn [key]=\"'btn'\" [btn]=\"{\n              type: 'button',\n              event: componentName + '#sort',\n              caption: (msg | async)['au.COMPONENT.KtsReportDownloadComponent.button.sort'],\n              params: {btnClass: {sm: true, type: 'decide'}}\n            }\" (clickBtn)=\"onEvent($event, 'sort', {})\"></item-btn>\n          </li>\n          <li [key]=\"'btn'\" buttonDir>\n            <item-btn [key]=\"'btn'\" [btn]=\"{\n              type: 'button',\n              event: componentName + '#displayChecked',\n              caption: (msg | async)['au.COMPONENT.KtsReportDownloadComponent.button.display_checked']\n            }\" (clickBtn)=\"onEvent($event, 'displayChecked', {})\"></item-btn>\n          </li>\n          <ng-template [ngIf]=\"display_checked\">\n            <li [key]=\"'btn'\" buttonDir>\n              <item-btn [key]=\"'btn'\" [btn]=\"{\n                type: 'button',\n                event: componentName + '#displayChecked',\n                caption: (msg | async)['au.COMPONENT.KtsReportDownloadComponent.button.display_all']\n              }\" (clickBtn)=\"onEvent($event, 'displayAll', {})\"></item-btn>\n            </li>\n          </ng-template>\n        </ul>\n      </ng-template>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <span class=\"sectionHeading sectionHeading-gray\">{{ (msg | async)['au.COMPONENT.KtsReportDownloadComponent.label.select_count'] }}{{ checkedItems.length }}{{ (msg | async)['au.COMPONENT.KtsReportDownloadComponent.label.select_count.unit'] }}</span>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <kts-report-download-list\n          [child]=\"true\"\n          [componentName]=\"componentName + 'File'\"\n          [component]=\"{name: componentName + 'File', params: {primaryKey: 'id', sortKey: 'disp_order', checkboxKey: 'is_checked', noKey: 'no', addable: false, deletable: false}}\"\n          [parentCols]=\"fileCols\"\n          [parentItems]=\"{items: getItems()}\"\n          (changeItems)=\"onChangeItems($event)\"></kts-report-download-list>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col -sm-12\">\n      <ng-template [ngIf]=\"zip == false\">\n        <ul [key]=\"'btn'\" buttonDir>\n          <li [key]=\"'btn'\" buttonDir>\n            <item-btn [key]=\"'btn'\" [btn]=\"{\n              type: 'button',\n              event: componentName + '#sort',\n              caption: (msg | async)['au.COMPONENT.KtsReportDownloadComponent.button.sort'],\n              params: {btnClass: {sm: true, type: 'decide'}}\n            }\" (clickBtn)=\"onEvent($event, 'sort', {})\"></item-btn>\n          </li>\n        </ul>\n      </ng-template>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsReportDownloadComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: KtsConstructionTaskService }
    ]; };
    return KtsReportDownloadComponent;
}(ContentBaseComponent));
export { KtsReportDownloadComponent };
var ConstructionFile = /** @class */ (function () {
    function ConstructionFile() {
        this.is_checked = false;
    }
    return ConstructionFile;
}());
export { ConstructionFile };
var ReportList = /** @class */ (function () {
    function ReportList(msg) {
        // 展開工事用
        this.expand = [];
        // 一般工事用
        this.general = [];
        this.outputFile = [];
        // 一括ダウンロード用
        this.zip_expand = [];
        this.zip_general = [];
        this.expand = [{
                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.list'],
                key: 'items',
                items: [{
                        key: 'id',
                        hidden: true,
                    }, {
                        key: 'is_checked',
                        hidden: true
                    }, {
                        key: 'construction_file_id',
                        hidden: true
                    }, {
                        label: msg['au.COMPONENT.KtsReportDownloadComponent.label.sort_id'],
                        items: [
                            {
                                controlType: 'number',
                                key: 'sort_id',
                                params: { formClass: { width: '75' }, options: { min: '0' } }
                            }
                        ]
                    }, {
                        label: msg['au.COMPONENT.KtsReportDownloadComponent.label.no'],
                        items: [
                            {
                                controlType: 'label',
                                key: 'no',
                            }
                        ]
                    }, {
                        label: msg['au.COMPONENT.KtsReportDownloadComponent.label.file'],
                        readonly: true,
                        items: [
                            {
                                controlType: 'label',
                                key: 'label',
                            }, {
                                controlType: 'break',
                            }, {
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.file'],
                                controlType: 'img',
                                key: 'file',
                                readonly: true,
                                params: {
                                    cache: false,
                                    style: {
                                        maxWidth: '200px'
                                    }
                                }
                            }
                        ]
                    }, {
                        label: msg['au.COMPONENT.KtsReportDownloadComponent.label.task_info'],
                        items: [
                            {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.task_name'] + '：',
                            }, {
                                controlType: 'label',
                                key: 'task_name',
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'text',
                                key: 'type',
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.term'] + '：',
                            }, {
                                controlType: 'label',
                                key: 'disp_term',
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.cdate'] + '：',
                            }, {
                                controlType: 'label',
                                key: 'cdate',
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.shooting_datetime'] + '：',
                            }, {
                                controlType: 'label',
                                key: 'shooting_datetime',
                            }
                        ]
                    },
                    {
                        label: msg['au.COMPONENT.KtsReportDownloadComponent.label.input_info'],
                        items: [
                            {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.shooting_date'] + '：',
                            },
                            {
                                controlType: 'date',
                                key: 'shooting_date',
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.shooting_location'] + ':',
                            }, {
                                controlType: 'text',
                                key: 'shooting_location',
                                params: {
                                    placeholder: msg['au.COMPONENT.KtsReportDownloadComponent.label.within20'],
                                    maxlength: 20
                                }
                            }, {}, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.subject'] + ':',
                            }, {
                                controlType: 'text',
                                key: 'subject',
                                params: {
                                    placeholder: msg['au.COMPONENT.KtsReportDownloadComponent.label.within20'],
                                    maxlength: 20
                                }
                            }, {
                                controlType: 'break',
                            }, {
                                controlType: 'label',
                                label: msg['au.COMPONENT.KtsReportDownloadComponent.label.content'] + '：',
                            }, {
                                controlType: 'textarea',
                                key: 'content',
                                params: {
                                    formClass: { width: '75per' },
                                    options: { rows: 5 },
                                    placeholder: msg['au.COMPONENT.KtsReportDownloadComponent.label.within160'],
                                    maxlength: 160
                                }
                            }
                        ]
                    }]
            }];
        this.general = JSOG.parse(JSON.stringify(this.expand));
        this.general[0].items[6].items.splice(0, 0, {
            controlType: 'label',
            label: msg['au.COMPONENT.KtsReportDownloadComponent.label.construction_class'] + '：',
        }, {
            controlType: 'label',
            key: 'disp_cc',
        }, {
            controlType: 'break',
        });
        this.zip_expand = JSOG.parse(JSON.stringify(this.expand));
        this.zip_general = JSOG.parse(JSON.stringify(this.general));
        // 一括ダウンロード画面では入力情報, 並べ替えID, No を非表示にする
        this.zip_expand[0].items.splice(7, 1);
        this.zip_expand[0].items.splice(3, 2);
        this.zip_general[0].items.splice(7, 1);
        this.zip_general[0].items.splice(3, 2);
    }
    return ReportList;
}());
export { ReportList };
//# sourceMappingURL=report-download.component.js.map